import { render, staticRenderFns } from "./CreateEditItem.vue?vue&type=template&id=4c788a7b"
import script from "./CreateEditItem.vue?vue&type=script&lang=js"
export * from "./CreateEditItem.vue?vue&type=script&lang=js"
import style0 from "./CreateEditItem.vue?vue&type=style&index=0&id=4c788a7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports